<template>
    <div>
        <div v-if="!isSpeq">
            <!-- Brand Logo -->
            <div class="brand-link px-4">
                <img
                    src="/images/logo-horizontal-white.png"
                    alt="SilencerCo"
                    class="brand-image"
                />
                <span class="brand-text font-weight-bold">DEALER PORTAL</span>
            </div>

            <!-- Sidebar -->
            <div class="sidebar">
                <!-- Sidebar user (optional) -->
                <div class="user-panel px-3 pb-4">
                    <div v-if="user.role.name == 'dealer_admin' || user.role.name == 'dealer_employee'" class="info">
                        <div class="name pb-2">{{ currentLocation.name }}</div>
                        <div v-if="currentLocation.address" class="store pb-2">
                            {{ currentLocation.address }}, <br />
                            {{ currentLocation.city }}, {{ currentLocation.state }},
                            {{ currentLocation.zip_code }}
                        </div>
                        <div
                            v-if="user.locations.length > 1"
                            class="change-store"
                            @click="modalShowStore = !modalShowStore"
                        >
                            <i class="fa-solid fa-pencil"></i> CHANGE LOCATION
                        </div>
                    </div>
                    <div v-else class="info">
                        <div class="name pb-2">{{ user.role.display_name }}</div>
                    </div>
                    
                    <!-- <div
                        v-if="
                            user.is_d2c_enabled &&
                            (user.role.name == 'dealer_admin' &&
                            user.first_location != null)
                        "
                    >
                        <router-link
                            class="btn btn-outline-orange text-orange text-uppercase float-end w-100 btn-join-d2d"
                            to="/direct-to-dealer-onboarding-landing"
                            v-if="!isD2DUser"
                        >
                            Join the Dealer Commission Program
                        </router-link>
                        <router-link
                            class="btn btn-outline-orange text-orange text-uppercase float-end w-100 btn-join-d2d"
                            to="/direct-to-dealer-onboarding-landing"
                            v-else
                        >
                            DEALER COMMISSION PROGRAM ENROLLED
                        </router-link>
                    </div> -->
                </div>

                <!-- TO SPEQ PORTAL -->
                <nav class="" v-if="isRoleTypeAdmin(user) || (currentLocation?.is_speq && currentLocation?.speq_invite_status == 3)">
                    <ul
                        class="nav nav-pills nav-sidebar flex-column"
                        data-widget="treeview"
                        role="menu"
                        data-accordion="false"
                    >
                        <li class="nav-item" @click="switchToSpeq">
                            <a aria-current="page" href="#" class="nav-link to-dealer-nav">
                                <p>
                                    <span class="text-speq">SPEQ PORTAL</span>
                                    <i class="nav-icon fa fa-arrow-right" aria-hidden="true"></i>
                                </p>
                            </a>
                        </li>
                    </ul>
                </nav>

                <!-- TO SPEQ PORTAL -->
                <nav class="" 
                    v-if="!currentLocation?.is_speq && 
                        (currentLocation?.speq_invite_status == 1 || 
                        currentLocation?.speq_invite_status == 2 || 
                        currentLocation?.speq_invite_status == 3)">
                    <ul
                        class="nav nav-pills nav-sidebar flex-column"
                        data-widget="treeview"
                        role="menu"
                        data-accordion="false"
                    >
                        <li class="nav-item" @click="speqOnboarding">
                            <a aria-current="page" href="#" class="nav-link to-dealer-nav">
                                <p>
                                    <span class="text-speq">SPEQ ONBOARDING</span>
                                    <i class="nav-icon fa fa-arrow-right" aria-hidden="true"></i>
                                </p>
                            </a>
                        </li>
                    </ul>
                </nav>

                <!-- DEALER COMMISSION -->
                <nav class="" v-if="user.is_d2c_enabled &&
                            (user.role.name == 'dealer_admin' &&
                            user.first_location != null)">
                    <ul
                        class="nav nav-pills nav-sidebar flex-column"
                        data-widget="treeview"
                        role="menu"
                        data-accordion="false"
                    >
                        <li class="nav-item">
                            <router-link
                                class="nav-link to-dealer-nav"
                                to="/direct-to-dealer-onboarding-landing"
                                v-if="!isD2DUser"
                            >
                                <p class="commission">
                                    <span class="commission-color">JOIN THE DEALER<br> COMMISSION PROGRAM</span>
                                    <i class="nav-icon fa fa-arrow-right" aria-hidden="true"></i>
                                </p>
                            </router-link>
                            <router-link
                                class="nav-link to-dealer-nav"
                                to="/direct-to-dealer-onboarding-landing"

                                v-else-if="!authUser.is_all_locations_enrolled"
                            >
                                <p class="commission">
                                    <span class="commission-color">DEALER COMMISSION PROGRAM ENROLLED</span>
                                    <i class="nav-icon fa fa-arrow-right" aria-hidden="true"></i>
                                </p>
                            </router-link>
                        </li>
                    </ul>
                </nav>

                <!-- Sidebar Menu for SUPER ADMIN, QUOTE APPROVER, SALES REPS, SALES ADMIN -->
                <nav class="mt-2">
                    <ul
                        class="nav nav-pills nav-sidebar flex-column"
                        data-widget="treeview"
                        role="menu"
                        data-accordion="false"
                    >
                        <li v-if="user.role_modules.includes('Dealer Users')" class="nav-item">
                            <router-link class="nav-link" to="/"
                                ><i
                                    class="nav-icon fa fa-users"
                                    aria-hidden="true"
                                ></i>
                                <p>DEALER USERS</p></router-link
                            >
                        </li>
                        <li v-if="user.role_modules.includes('Dealers')" class="nav-item">
                            <router-link class="nav-link" to="/dealers"
                                ><i
                                    class="nav-icon fa fa-address-card"
                                    aria-hidden="true"
                                ></i>
                                <p>DEALERS</p></router-link
                            >
                        </li>
                        <li
                            v-if="user.role_modules.includes('Admin Users')"
                            class="nav-item"
                        >
                            <router-link class="nav-link" to="/sales-reps"
                                ><i
                                    class="nav-icon fa fa-user"
                                    aria-hidden="true"
                                ></i>
                                <p>ADMIN USERS</p></router-link
                            >
                        </li>
                        <li v-if="user.role_modules.includes('Dashboard')" class="nav-item">
                            <router-link class="nav-link" to="/"
                                ><i
                                    class="nav-icon fa-solid fa-gauge"
                                    aria-hidden="true"
                                ></i>
                                <p>DASHBOARD</p></router-link
                            >
                        </li>
                        <li v-if="user.role_modules.includes('Orders')" class="nav-item">
                            <router-link class="nav-link" to="/all-orders"
                                ><i
                                    class="nav-icon fa fa-tasks"
                                    aria-hidden="true"
                                ></i>
                                <p>ORDERS</p></router-link
                            >
                        </li>
                        <li v-if="user.role_modules.includes('Synced Orders')" class="nav-item">
                            <router-link class="nav-link" to="/synced-orders"
                                ><i
                                    class="nav-icon fa fa-tasks"
                                    aria-hidden="true"
                                ></i>
                                <p>SYNCED ORDERS</p></router-link
                            >
                        </li>
                        <li v-if="user.role_modules.includes('Admin New Order')" class="nav-item">
                            <router-link class="nav-link" to="/new-order-admin"
                                ><i
                                    class="nav-icon fa fa-cart-plus"
                                    aria-hidden="true"
                                ></i>
                                <p>NEW ORDER</p>
                                <span class="order-count" v-if="orderCount > 0">{{
                                    orderCount
                                }}</span></router-link
                            >
                        </li>
                        <li v-if="['dealer_admin','dealer_employee'].includes(user.role.name) && user.online_order" class="nav-item">
                            <router-link class="nav-link" to="/new-order"
                                ><i
                                    class="nav-icon fa fa-cart-plus"
                                    aria-hidden="true"
                                ></i>
                                <p>NEW ORDER</p>
                                <span class="order-count" v-if="orderCount > 0">{{
                                    orderCount
                                }}</span></router-link
                            >
                        </li>
                        <li v-if="['dealer_admin'].includes(user.role.name) || user.bogo_orders_count > 0" class="nav-item">
                            <router-link class="nav-link" to="/all-bogo-orders"
                                ><i
                                    class="nav-icon fa fa-tasks"
                                    aria-hidden="true"
                                ></i>
                                <p>BOGO ORDERS</p></router-link
                            >
                        </li>
                        <li v-if="currentLocation?.is_speq == 1" class="nav-item">
                            <router-link class="nav-link" to="/speq/new-speq-orders"
                                ><i
                                    class="nav-icon fa fa-tasks"
                                    aria-hidden="true"
                                ></i>
                                <p>SPEQ ORDERS</p></router-link
                            >
                        </li>
                        <li
                            v-if="user.quote_access && user.role_modules.includes('Quotes')"
                            class="nav-item"
                        >
                            <router-link class="nav-link" to="/quotes"
                                ><i
                                    class="nav-icon fa fa-usd"
                                    aria-hidden="true"
                                ></i>
                                <p>QUOTES</p></router-link
                            >
                        </li>
                        <li v-if="user.role_modules.includes('Invoices')" class="nav-item">
                            <router-link class="nav-link" to="/invoices"
                                ><i
                                    class="nav-icon fa fa-list"
                                    aria-hidden="true"
                                ></i>
                                <p>INVOICES</p></router-link
                            >
                        </li>
                        <li v-if="user.role_modules.includes('Open Order Lines')" class="nav-item">
                            <router-link class="nav-link" to="/order-lines-report"
                                ><i
                                    class="nav-icon fa fa-list"
                                    aria-hidden="true"
                                ></i>
                                <p>OPEN ORDER LINES</p></router-link
                            >
                        </li>
                        <li v-if="user.role_modules.includes('Materials')" class="nav-item">
                            <router-link class="nav-link" to="/all-materials"
                                ><i
                                    class="nav-icon fa fa-folder-open"
                                    aria-hidden="true"
                                ></i>
                                <p>MATERIALS</p></router-link
                            >
                        </li>
                        <li v-if="user.role_modules.includes('Available Inventory')" class="nav-item">
                            <router-link
                                class="nav-link"
                                to="/all-available-inventories"
                                ><i
                                    class="nav-icon fa fa-folder-open"
                                    aria-hidden="true"
                                ></i>
                                <p>AVAILABLE INVENTORY</p></router-link
                            >
                        </li>
                        <!--<li v-if="user.role_modules.includes('SOT/FFL APPROVAL QUEUE')" class="nav-item">
                            <router-link class="nav-link" to="/approval-queue"
                                ><i
                                    class="nav-icon fa fa-folder-open"
                                    aria-hidden="true"
                                ></i>
                                <p class="small">
                                    SOT/FFL APPROVAL QUEUE
                                </p></router-link
                            >
                        </li> -->
                        <li v-if="['super_admin','quote_approver','sales_reps','sales_admin'].includes(user.role.name) && user.role_modules.includes('Price List')" class="nav-item">
                            <router-link class="nav-link" to="/admin-price-list"
                                ><i
                                    class="nav-icon fa fa-usd"
                                    aria-hidden="true"
                                ></i>
                                <p>PRICE LIST</p></router-link
                            >
                        </li>
                        <li v-if="['dealer_admin','dealer_employee'].includes(user.role.name) && user.role_modules.includes('Price List')" class="nav-item">
                            <router-link class="nav-link" to="/price-lists"
                                ><i
                                    class="nav-icon fa fa-usd"
                                    aria-hidden="true"
                                ></i>
                                <p>PRICE LIST</p></router-link
                            >
                        </li>
                        <li v-if="user.role_modules.includes('Contact')" class="nav-item">
                            <router-link class="nav-link" to="/contact"
                                ><i
                                    class="nav-icon fa fa-envelope"
                                    aria-hidden="true"
                                ></i>
                                <p>CONTACT</p></router-link
                            >
                        </li>
                        <li v-if="user.role_modules.includes('Commissions') && isD2DUser" class="nav-item">
                            <router-link class="nav-link" to="/commissions"
                                ><i
                                    class="nav-icon fa fa-envelope"
                                    aria-hidden="true"
                                ></i>
                                <p>COMMISSIONS</p></router-link
                            >
                        </li>
                        <!-- ONLY SUPER ADMIN -->
                        <!-- <li
                            v-if="['super_admin'].includes(user.role.name) || 
                                buy_group_dates_users_with_access.includes(user.id)
                            "
                            class="nav-item"
                        >
                            <router-link class="nav-link" to="/buy-group-dates"
                                ><i
                                    class="nav-icon fa fa-folder-open"
                                    aria-hidden="true"
                                ></i>
                                <p>BUY GROUP DATES</p></router-link
                            >
                        </li> -->
                        <!-- ONLY SUPER ADMIN -->
                        <!-- <li v-if="['super_admin'].includes(user.role.name)" class="nav-item">
                            <router-link
                                class="nav-link"
                                to="/free-shipping-settings"
                                ><i
                                    class="nav-icon fa fa-gear"
                                    aria-hidden="true"
                                ></i>
                                <p>FREE SHIPPING SETTINGS</p></router-link
                            >
                        </li> -->
                        <!-- ONLY SUPER ADMIN -->
                        <li v-if="['super_admin'].includes(user.role.name)" class="nav-item">
                            <router-link
                                class="nav-link"
                                to="/settings"
                                ><i
                                    class="nav-icon fa fa-gear"
                                    aria-hidden="true"
                                ></i>
                                <p>SETTINGS</p></router-link
                            >
                        </li>
                        
                    </ul>
                </nav>
                <!-- /.sidebar-menu -->

                <!-- Sidebar Menu for DEALER ADMIN -->
                <nav class="mt-2">
                    <ul
                        class="nav nav-pills nav-sidebar flex-column"
                        data-widget="treeview"
                        role="menu"
                        data-accordion="false"
                    >
                        
                    </ul>
                </nav>
                <!-- /.sidebar-menu -->

                

                <!-- DATA DISCLAIMER -->
                <nav class="mt-5">
                    <ul
                        class="nav nav-pills nav-sidebar flex-column"
                        data-widget="treeview"
                        role="menu"
                        data-accordion="false"
                    >
                        <li class="nav-item">
                            <div class="disclaimer">
                                <span class="text-muted">Data Disclaimer:</span
                                ><br />
                                <span class="text-muted"
                                    >Your portal data is refreshed once per
                                    day</span
                                >
                            </div>
                        </li>
                    </ul>
                </nav>

                <!-- <nav v-if="user.role.id == 1 || currentLocation?.is_speq == 1">
                    <button
                        class="btn btn-speq-toggle mt-2 mb-4"
                        @click="switchToSpeq"
                    >
                        SPEQ PORTAL
                    </button>
                </nav> -->

                <!-- Brand Logo -->
                <div class="brand-link px-4 brand-logo-bottom mb-2">
                    <img
                        src="/images/emblem-light.png"
                        alt="SilencerCo"
                        class="brand-image"
                    />
                </div>

                
            </div>

            <!-- /.sidebar -->
            <!-- Add sub user modal -->
            <b-modal v-model="modalShowStore" title="Change Location" hide-footer>
                <ChangeStoreModal
                    v-if="modalShowStore"
                    @close-modal="closeModalStore"
                />
            </b-modal>
        </div>
        <div v-else>
            <side-bar-nav-speq :user="user" />
        </div>

        <div v-if="['super_admin','sales_reps','sales_admin','quote_approver'].includes(user.role.name)" class="report-bug">
            <a href="https://form.asana.com/?k=Mz1cWLI352wr5rs_4dBb_A&d=23076171468403" class="report-container" target="_blank">
                <img
                    src="/images/report_bug.svg"
                    alt="SilencerCo"
                    class="brand-image"
                />
                REQUEST FEATURE OR REPORT BUG
            </a>
        </div>
    </div>
</template>

<script>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";
import SideBarNavSpeq from "./SideBarNavSpeq.vue";

import ChangeStoreModal from "./modals/ChangeStoreModal.vue";
import { isRoleTypeAdmin } from "@/helpers";
import { isSuperAdmin } from "../helpers";

export default {
    props: ["user"],
    emits: [],
    components: {
        ChangeStoreModal,
        SideBarNavSpeq,
    },
    setup() {
        const store = useStore();

        const authUser = computed(() => {
          return store.getters.user;
        });

        let currentLocation = computed(function () {
            return store.state.currentLocation;
        });
        let orders = computed(function () {
            return store.state.orders;
        });
        let isD2DUser = computed(function () {
            return store.state.isD2DUser;
        });

        let isSpeq = computed(function () {
            return store.state.isSpeq;
        });

        function setUser(val) {
            store.commit("setUser", val);
        }

        function setCurrentLocation(val) {
          store.commit("setCurrentLocation", val);
        }

        function checkIsD2DUser() {
            store.dispatch("getIsD2DUser");
        }

        onMounted(() => {});

        return {
            isRoleTypeAdmin,
            currentLocation,
            isD2DUser,
            orders,
            isSpeq,
            setUser,
            setCurrentLocation,
            checkIsD2DUser,
            authUser
        };
    },
    data() {
        return {
            modalShowStore: false,
            buy_group_dates_users_with_access: JSON.parse(
                process.env.MIX_BUY_GROUP_DATES_USERS_WITH_ACCESS
            ),
            showD2Dbtn: false,
        };
    },
    computed: {
        orderCount() {
            let ctr = 0;
            if (this.orders) {
                for (let x = 0; x < this.orders.length; x++) {
                    if (this.orders[x].quantity > 0) {
                        ctr += this.orders[x].quantity;
                    }
                }
            }

            return ctr;
        },
    },
    mounted() {
        this.setUser(this.user);
        if (this.user.role.id != 1) {
            this.checkIsD2DUser();
        }

        this.$store.dispatch("getSettings", {
            location_id: this.currentLocation.id,
        });

        // Check if previous session was speq
        // @TODO update to add user validation later
        let isSpeq = localStorage.getItem("isSpeq");
        if (isSuperAdmin(this.user)) {
            // this.$store.commit("setIsSpeq", isSpeq);
            // if (this.isSpeq) {
            if (isSpeq == 'true') {
                // this.switchToSpeq()
                this.$store.commit("setIsSpeq", true);
                localStorage.setItem("isSpeq", true);
            }
        } else {
            // if (this.isSpeq) {
            if (isSpeq == 'true') {
                // this.switchToSpeq()
                this.$store.commit("setIsSpeq", true);
                localStorage.setItem("isSpeq", true);
            }
        }

        // if (this.user.role.name != "super_admin") {
        if (this.user.role.name == 'dealer_admin' || this.user.role.name == 'dealer_employee') {
            if (this.currentLocation.id) {
                // do nothing
            } else {
                //
                if (this.user.locations.length > 1) {
                    let __is_speq = 0;
                    let __speq_invite_status = 0;

                    // this.user.locations_arr?.forEach((data) => {
                    //     if (data.is_speq)  __is_speq = 1;
                    //     if (data.speq_invite_status)  __speq_invite_status = 1;
                    // })
                    let selectedLocation = {
                        id: 0,
                        pricelist_id: 0,
                        name: "ALL LOCATIONS",
                        sales_rep: this.user.first_location.location.sales_rep,
                        is_speq: __is_speq,
                        speq_invite_status: __speq_invite_status
                    };
                    this.setCurrentLocation(selectedLocation);
                } else {
                    this.setCurrentLocation(this.user.first_location.location);
                }
            }

            if (!localStorage.hasOwnProperty("orders")) {
                localStorage.setItem("orders", JSON.stringify([]));
            }
            if (!localStorage.hasOwnProperty("po_number")) {
                localStorage.setItem("po_number", "");
            }
        } else {
            if (!localStorage.hasOwnProperty("products")) {
                localStorage.setItem("products", JSON.stringify([]));
            }
            if (!localStorage.hasOwnProperty("orders")) {
                localStorage.setItem("orders", JSON.stringify([]));
            }
            if (!localStorage.hasOwnProperty("po_number")) {
                localStorage.setItem("po_number", "");
            }
        }
        this.checkD2D();

        // $('.nav-sidebar .nav-item').on('click', function() {
        //     console.log('jack')
        //     $('.main-sidebar').attr('style','margin-left: -250px')
        // })

    },
    methods: {
        closeModalStore() {
            this.modalShowStore = !this.modalShowStore;
            this.checkD2D();
        },

        checkD2D() {
            if (this.user.role.id != 1) {
                axios.get("/api/check-d2d-eligible").then((res) => {
                    this.showD2Dbtn = true;
                });
            }
        },
        switchToSpeq() {
            this.$store.commit("setIsSpeq", true);
            localStorage.setItem("isSpeq", true);
            this.$router.push({ name: "speqDashboard" });
        },
        speqOnboarding() {
            this.$router.push({ name: "speqOnboarding" });
        },
    },
};
</script>
<style scoped>
.btn-join-d2d {
    font-size: 12px;
    word-wrap: break-word;
    white-space: break-spaces;
}
.btn-join-d2d:hover,
.btn-join-d2d.active {
    color: white !important;
}
</style>
